import { render, staticRenderFns } from "./ShippingAddressModal.vue?vue&type=template&id=573b9405&scoped=true"
import script from "./ShippingAddressModal.vue?vue&type=script&lang=js"
export * from "./ShippingAddressModal.vue?vue&type=script&lang=js"
import style0 from "./ShippingAddressModal.vue?vue&type=style&index=0&id=573b9405&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573b9405",
  null
  
)

export default component.exports